import React from "react";

function FundTransTable(props) {
  const { data, totalValues } = props;

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper tax-table">
        <table className="table last-column">
          <thead>
            <>
              <tr className="">
                <th scope="col">Date</th>
                <th scope="col">Transaction Details</th>
                <th scope="col">Payment</th>
                <th scope="col">Receipt (₹)</th>
              </tr>
            </>
          </thead>
          <tbody>
            {data &&
              data.map((item, key) => {
                return (
                  <>
                    <tr key={key} className="">
                      <td>{item?.date || "-"}</td>
                      <td>{item?.transactionDetails || "-"}</td>
                      <td>{item?.payment || 0}</td>
                      <td>{item?.receipt || 0}</td>
                    </tr>
                  </>
                );
              })}
          </tbody>

          <tbody className="tax-total-values">
            <tr>
              <td>Total</td>
              <td></td>
              <td>{totalValues.totalPayment}</td>
              <td>{totalValues.totalReceipt}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
export default FundTransTable;
